module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.single) ? _c('div', {
    staticClass: "is-relative"
  }, [_c('h3', {
    staticClass: "stepper__content__header"
  }, [_vm._v(_vm._s(_vm.$t('CAN_I_USE_BRASTER')))])]) : _vm._e(), _vm._v(" "), _c('steps', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "activeStep": 3,
      "steps": 4
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper flex-center"
  }, [_c('h4', {
    staticClass: "stepper__content__title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('SURGERY_AROUND_CHEST')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "stepper__content__title-description"
  }, [_vm._v(_vm._s(_vm.$t('SURGERY_AROUND_CHEST_DETAILS')))]), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper flex-center flex-row"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s2q3Val),
      expression: "s2q3Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "name": "s2q3Val",
      "value": "YES"
    },
    domProps: {
      "checked": _vm._q(_vm.s2q3Val, "YES")
    },
    on: {
      "click": function($event) {
        return _vm.disallowByBreastSurgery()
      },
      "change": function($event) {
        _vm.s2q3Val = "YES"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s2q3Val),
      expression: "s2q3Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "name": "s2q3Val",
      "value": "NO"
    },
    domProps: {
      "checked": _vm._q(_vm.s2q3Val, "NO")
    },
    on: {
      "click": _vm.goNext,
      "change": function($event) {
        _vm.s2q3Val = "NO"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('NO')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29409752","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey-step2-q3.vue
// module id = 1176
// module chunks = 0